module.exports = __webpack_public_path__ + "img/759e621.jpg";